angular.module('unergie.main')
    .controller('ecoSessionCtrl', ($scope, $filter, $uibModal, $stateParams, $timeout, MS, NgTableParams, DataAccess, CommonRegex, AuthService, ModalService,
                                   ApiUser, XmlParser, FileUploader, DataAccessSearch, AlertManager, MetaWatcher, BoFeaturesService, ContactInformationB2G, ErrorCatcher) => {

        $scope.type = 'ECOSESSION'
        $scope.orgContacts = ContactInformationB2G
        $scope.selected = {}
        $scope.search = {
            brand: null
        }

        $scope.popupValidationFields = {
            label: {
                label: 'Je confirme que :',
                type: 'label',
            },
            check1: {
                label: `Je valide l'intégralité des inscriptions qui me sont proposées.`,
                type: 'checkbox',
                check: (template) => template.check1,
            }
        }

        $scope.popupRefusalFields = {
            label: {
                label: 'Je confirme que :',
                type: 'label',
            },
            check1: {
                label: `Je refuse l'intégralité de l'inscription qui m'est proposé`,
                type: 'checkbox',
                check: (template) => template.check1,
            },
            check2: {
                label: `Être habilité(e) pour refuser ces propositions d'ecosession.`,
                type: 'checkbox',
                check: (template) => template.check2,
            },
        }

        $scope.popupValidationTemplate = {}
        $scope.popupRefusalTemplate = {}


        $scope.refreshAccount = (account) => {
            if (account) {
                $scope.search.brand = account.brand
                $scope.selected.account = account
            }
            MetaWatcher.notif('MNG_ACCOUNT_CHANGED')
        }

        $scope.ecosessionUploader = new FileUploader({
            url: `/api-user/ecosession/upload-xlsx`,
            alias: 'file',
            formData: [{id_account: $scope.selected.account && $scope.selected.account.id_account}],
            autoUpload: true,
            method: 'POST',
            onBeforeUploadItem() {
                $scope.response = null
                $scope.errorMessage = null
                $scope.errorDetails = []
            },
            onSuccessItem(item, response) {
                AlertManager.success(`Choix importés, cliquez sur "Valider les choix importés" pour les sauvegarder`)
                const grouped = _.groupBy(response, (elem) => `${elem.status}>${elem.new_status || elem.status}`)
                $scope.response = {
                    nbTotal: response.length,
                    sumup: _.map(grouped, (list, modif) => {
                        const [status, new_status] = modif.split('>')
                        return {status, new_status, nb: list.length}
                    }),
                    list: response,
                }
            },
            onErrorItem(item, response, status, headers) {
                $scope.errorMessage = response.message
                $scope.errorDetails = _.castArray(response.detail)
            }
        })

        const updateAccount = () => {
            if ($scope.selected.account) {
                $scope.ecosessionUploader.formData = [{
                    id_account: $scope.selected.account.id_account,
                    type: $scope.type
                }]
                $scope.parseResult = undefined
            }
        }

        $scope.updatePage = () => {
            $scope.accountsTable = null
            $scope.updatingPage = true
            return ($scope.selectedOrg ? Promise.resolve($scope.selectedOrg) : DataAccess.myOrganizations().$promise
                .then((myOrganizations) => {
                    $scope.organizations = myOrganizations
                    if (myOrganizations.length === 1) {
                        $scope.selectedOrg = myOrganizations[0]
                        return myOrganizations[0].id
                    }
                }))
                .then((organization) => {
                    if (organization) {
                        $scope.selectedOrgObject = _.find($scope.organizations, {id: organization})
                        const orgType = $scope.selectedOrgObject.type
                        $scope.orgContact = _.assign({}, $scope.orgContacts[`default_${orgType}`], $scope.selectedOrgObject.contact_infos)
                        return DataAccess.myEcosessionAccounts({organization, type: $scope.type}).$promise
                            .then((accounts) => {
                                const selectedId = ($scope.selected.account && ($scope.selected.account.organization === organization) && $scope.selected.account.id) || $stateParams.id_account
                                $scope.accounts = accounts
                                if ($scope.accounts.length) {
                                    if (!selectedId) {
                                        $scope.selected = {
                                            account: $scope.accounts[0],
                                        }
                                    } else {
                                        $scope.selected = {
                                            account: _.find($scope.accounts, {id: selectedId}),
                                        }
                                    }
                                    if ($scope.accounts.length > 1 || $scope.isAdmin) {
                                        $scope.accountsTable = new NgTableParams({}, {dataset: $scope.accounts})
                                    }
                                    $scope.refreshAccount($scope.selected.account)
                                } else {
                                    $scope.selected.optimizations = null
                                    $scope.selected.account = null
                                }
                            })
                            .catch(ErrorCatcher)
                    }
                })
                .finally(() => {
                    $timeout(() => {
                        $scope.updatingPage = false
                    })
                })
        }

        $scope.canValidate = () => {
            return !!$scope.response
        }

        $scope.validateEcosession = (noMail) => {
            $scope.validationEcosession = true
            const payload = $scope.response.list.parsed.prmFilter
            return ApiUser.validateEcosession({
                id_account: $scope.selected.account.id_account,
                noMail
            }, payload)
                .$promise
                .then((result) => {
                    AlertManager.success(`Choix validés`, 10000)
                    $scope.response = null
                    $scope.updatePage()
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.validationEcosession = false
                })
        }

        $scope.validateEcosessionAsIs = (refuse) => {
            $scope[`${refuse ? 'refusing' : 'validating'}EcosessionAsIs`] = true
            return ApiUser.validateEcosessionAsIs({
                id_account: $scope.selected.account.id_account,
                status: refuse ? 'REFUSED' : 'VALIDATED'
            }, {}).$promise
                .then((result) => {
                    $scope.response = null
                    AlertManager.success(`Ecosessions ${refuse ? 'refusées' : 'validées'}`, 10000)
                    $scope.updatePage()
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope[`${refuse ? 'refusing' : 'validating'}EcosessionAsIs`] = false
                })
        }

        $scope.refreshTable2 = (account) => {
            if (account) {
                $scope.selected.account = account
            }
        }

        // IMPORT
        $scope.importUploader = new FileUploader({
            url: '/api-admin/s3-upload',
            alias: 'file',
            formData: [
                {
                    bucketName: 'files',
                    path: 'ecosessions-import'
                }],
            autoUpload: true,
            method: 'POST',
            onSuccessItem(item, response, status, headers) {
                AlertManager.success(`Fichier d'ecosession uploadé - lancement du traitement`)
                $scope.parsing = true
                const payload = {
                    source: 's3',
                    bucket: response.bucket,
                    type: 'ecosessions',
                    filename: response.path,
                }
                return XmlParser
                    .parsing(payload)
                    .$promise
                    .then((result) => {
                        ModalService
                            .openModal(
                                {
                                    type: 'resultModal',
                                    size: 'lg'
                                },
                                {
                                    result
                                }
                            )
                        $scope.updatePage()
                    })
                    .catch(ErrorCatcher)
                    .finally(() => {
                        $scope.parsing = false
                    })
            },
            onErrorItem(item, response, status, headers) {
                AlertManager.error(response.message, 10000)
            }
        })

        MetaWatcher.watch('MNG_ACCOUNT_CHANGED', 'ecoSession', $scope, updateAccount)

        const activate = () => {
            $scope.updatePage()
        }

        activate()
    });
